import { getUniversalOutForm } from '@/services/universalForm'
import { universalPermissions } from '@/services/smart'
import i18n from '@/lib/language'

const state = {
  loading: true,
  formData: {},
  confrimConfig: {},
  fromOtherOptions: [],
  fromIpOptions: [],
  configFormError: false,
  compareFieldError: false,
  result: {},
  permissions: {}
}

const getters = {}

const mutations = {
  SET_LOADING (state, data) {
    state.loading = data
  },
  SET_FORM_DATA (state, data) {
    state.formData = data
    let deploy = data.deploy || {}
    state.confrimConfig = deploy.config || {}
    // 处理来源checkbox选项的旧数据
    if (
      state.confrimConfig.form_config &&
      typeof state.confrimConfig.form_config.from_other === 'boolean'
    ) {
      state.confrimConfig.form_config.from_other = []
    }

    // 处理来源的选项
    if (deploy.base_info && deploy.base_info.child) {
      for (let item of deploy.base_info.child) {
        let { fieldconfig = {}, fieldtype } = item
        if (fieldtype === 'radioinfo_level') {
          let arr = []
          if (fieldconfig.type === 1) {
            arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
          } else if (fieldconfig.type === 2) {
            arr = i18n.t('message["1444"]').split(',')
          }
          item.options.forEach((item, index) => {
            arr.forEach((code, i) => {
              if (index === i) {
                item.name = code
              }
            })
          })
        }
      }
    }
  },
  setFromOtherOptions (state) {
    let deploy = state.formData.deploy || {}
    let val = 0
    state.fromOtherOptions = []
    state.fromIpOptions = []
    if (state.confrimConfig.form_config.from_type === 0) {
      val =
        deploy.from_info &&
        deploy.from_info.child &&
        deploy.from_info.child[0] &&
        deploy.from_info.child[0].id
    } else {
      val = state.confrimConfig.form_config.from_type
    }
    if (deploy.from_info && deploy.from_info.child) {
      for (let child of deploy.from_info.child) {
        if (val === child.id) {
          for (let item of child.child) {
            let obj = {
              fieldkey: item.fieldkey,
              fieldname: item.fieldname
            }
            if (item.fieldtype === 'text') {
              state.fromOtherOptions.push(obj)
            } else if (item.fieldtype === 'ip') {
              state.fromIpOptions.push(obj)
            }
          }
        }
      }
    }
  },
  setConfrimConfig (state, data) {
    state.confrimConfig = data
  },
  setConfigFormError (state, data) {
    state.configFormError = data
  },
  setFieldsConfig (state, data) {
    state.formData.config = data
  },
  setCompareFieldError (state, data) {
    state.compareFieldError = data
  },
  setPermissions (state, data) {
    state.permissions = data
  }
}

const actions = {
  async fetchFormData ({ commit, dispatch }) {
    commit('SET_LOADING', true)
    const chain = await getUniversalOutForm()
    chain.onSuccess(async payload => {
      await commit('SET_FORM_DATA', payload)
      commit('setFromOtherOptions')
      commit('SET_LOADING', false)
    })
    return chain
  },
  // 获取外部表单权限相关
  async getUniversalPermissions ({ commit }) {
    commit('SET_LOADING', true)
    const chain = await universalPermissions()
      .params()
      .onSuccess(res => {
        commit('setPermissions', res)
      })
      .fetch()
    return chain
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
